document.addEventListener('DOMContentLoaded', () => {
  (async () => {
    const shippingInfoDivId = 'dynamic-shipping-cost';
    let lastSubtotal = null;
    let locationValid = false; // Flag om te controleren of de locatie geldig is

    const addPlaceholder = () => {
      const placeholder = document.getElementById('shipping-estimate-placeholder');
      if (!placeholder) return;
      // Zet initiële tekst of leeg maken
      placeholder.innerText = 'Verzendkosten aan het berekenen...';
    };

    const getLocation = async () => {
      const cached = localStorage.getItem('user_country');
      if (cached) return { country: cached };

      try {
        const response = await fetch('https://ipinfo.io/json?token=aa4df0a216f560');
        if (!response.ok) throw new Error('API probleem');
        const data = await response.json();
        if (data.country) {
          localStorage.setItem('user_country', data.country);
          locationValid = true;  // Locatie is nu geldig
        }
        return data;
      } catch (e) {
        console.error('Locatie ophalen mislukt:', e);
        locationValid = false; // Locatie is niet geldig
        return { country: 'default' };
      }
    };

    const getShippingRate = (country, subtotal) => {
      const rates = {
        'NL': '€2,99',
        'BE': '€4,99',
        'DE': '€14,99',
        'default': '€14,99'
      };
      const freeShippingThresholds = {
        'NL': 3000,  // €30 voor Nederland
        'BE': 5000,  // €50 voor België
      };

      const isFreeShippingCountry = ['NL', 'BE'].includes(country);
      const isEligibleForFreeShipping = subtotal >= (freeShippingThresholds[country] || 0);

      if (isFreeShippingCountry && isEligibleForFreeShipping) {
        return 'Gratis verzending';
      }

      return rates[country] || rates['default'];
    };

    const getCartSubtotal = async () => {
      try {
        const res = await fetch('/cart.js');
        if (!res.ok) throw new Error('Cart ophalen mislukt');
        const cart = await res.json();
        return cart.total_price;
      } catch (err) {
        console.error(err);
        return 0;
      }
    };

    const updateShippingDisplay = async (countryCode) => {
      const subtotal = await getCartSubtotal();
      if (subtotal === lastSubtotal) return; // alleen updaten als er iets veranderd is
      lastSubtotal = subtotal;

      const rate = getShippingRate(countryCode, subtotal);
      const placeholder = document.getElementById('shipping-estimate-placeholder');
      if (placeholder) {
        placeholder.innerText = `Geschatte verzendkosten voor ${countryCode}: ${rate}`;
      }
    };

    const updateTotalPrice = async (countryCode) => {
      // Haal het subtotaal op van de winkelwagen
      const subtotal = await getCartSubtotal();
      if (subtotal === lastSubtotal) return; // Alleen updaten als er iets veranderd is
      lastSubtotal = subtotal;

      // Als de locatie niet geldig is, toon de totaalprijs niet
      if (!locationValid) {
        return;
      }

      // Haal de verzendkosten op
      const shippingRate = getShippingRate(countryCode, subtotal);

      // Als het gratis verzending is, stellen we de verzendkosten in op 0
      let shippingCost = shippingRate === 'Gratis verzending' ? 0 : parseFloat(shippingRate.replace('€', '').replace(',', '.'));

      // Bereken de totaalprijs (subtotaal + verzendkosten)
      const totalPrice = subtotal + shippingCost;

      // Update de verzendkosten display
      const placeholder = document.getElementById('shipping-estimate-placeholder');
      if (placeholder) {
        placeholder.innerText = `Geschatte verzendkosten voor ${countryCode}: ${shippingRate}`;
      }

      // Update het finale totaal in de UI
      const finalTotalElement = document.getElementById('final-total');
      if (finalTotalElement) {
        finalTotalElement.innerText = `${(totalPrice / 100).toFixed(2)} €`; // Aannemende dat je prijs in centen is
      }
    };

    // Initialisatie
    addPlaceholder();
    const location = await getLocation();
    const countryCode = location?.country || 'default';
    await updateShippingDisplay(countryCode);
    await updateTotalPrice(countryCode);

    // ⏱ Herhaal elke 2 seconden
    setInterval(() => {
      updateShippingDisplay(countryCode);  // Update verzendkosten
      if (locationValid) {
        updateTotalPrice(countryCode);  // Update totaalprijs alleen als locatie geldig is
      }
    }, 2000);
  })();
});
